import { AppLoader } from '@/components/AppLoader';
import { config } from '@/config';
import { useCurrentUserContext } from '@/contexts';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { Redirect } from '@/router/components/Redirect';
import { Box, Flex, Text } from '@/ui';
import { TemplatesTable } from './components/TemplatesTable';

const isProduction =
  config.env === 'production' &&
  !config.isPreviewDeploy &&
  !config.isLocalProdBuild;

export const TemplatesPage = () => {
  const { isAuthenticated, isLoading } = useCurrentUserContext();

  if (isLoading) {
    return <AppLoader />;
  }
  if (!isAuthenticated) {
    return <Redirect path="/auth" />;
  }

  return <AuthenticatedTemplatesPage />;
};

const AuthenticatedTemplatesPage = () => {
  const { value: isEnabled, loading: isFeatureFlagLoading } = useFeatureFlag(
    'templatesAdminEnabled'
  );

  if (isFeatureFlagLoading) {
    return <AppLoader />;
  }
  if (!isEnabled) {
    return <Redirect path="/" />;
  }

  return (
    <Box
      maxW="1100px"
      minH="100vh"
      minW={{ md: '800px' }}
      mx="auto"
      p={6}
      w="100%"
    >
      <Flex align="center" gap={3} mb={6}>
        <Text fontSize="2xl" fontWeight="bold">
          Templates
        </Text>
        {isProduction && (
          <Box
            bg="red.500"
            borderRadius="md"
            color="white"
            fontSize="xs"
            fontWeight="bold"
            letterSpacing="wider"
            px={2}
            py={1}
          >
            PRODUCTION
          </Box>
        )}
      </Flex>
      <TemplatesTable />
    </Box>
  );
};
